import { PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import s from './IntroModalContent.module.scss';
import { Typography } from '../../../components';
import Point from './Point';

type Props = {
  heading: string;
  iconComponent: ReactNode;
  points: string[];
};

function IntroModalContent({
  children,
  iconComponent,
  heading,
  points,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation('intro');
  return (
    <>
      <header>
        <div className={s.icon}>{iconComponent}</div>
        <Typography kind="h2" fontWeight={700} className={s.heading}>
          {heading}
        </Typography>
      </header>

      <section>
        <Typography
          kind="h3"
          size="m"
          fontWeight={700}
          className={s['section-heading']}
        >
          {t('how_it_works')}
        </Typography>

        <div className={s.box}>
          {points.map((point, index) => (
            <Point key={point} number={index + 1} description={point} />
          ))}
        </div>
      </section>

      {children !== undefined && <section>{children}</section>}
    </>
  );
}

export default IntroModalContent;
